// Declaração do gtag para TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    gtag_report_conversion?: (url?: string) => boolean;
  }
}

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePhoneClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  const handleWhatsAppClick = () => {
    // Rastrear conversão no Google Ads
    if (window.gtag_report_conversion) {
      window.gtag_report_conversion();
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-800 to-gray-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-4">
            <img
              src="https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/261197e3c61643879bf9283aac305692.png"
              alt="JB PINTURAS"
              className="h-20 w-auto object-contain"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Mais de 20 anos transformando ambientes em São José dos Campos e Vale do Paraíba com
              qualidade e profissionalismo.
            </p>
            <div className="flex items-center space-x-2">
              <i className="ri-map-pin-line text-orange-400"></i>
              <span className="text-sm">São José dos Campos - SP</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-file-text-line text-orange-400"></i>
              <span className="text-sm">CNPJ: 29.017.962/0001-35</span>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold text-orange-400 mb-4">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Home</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('servicos')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Serviços</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Portfólio</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('depoimentos')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Depoimentos</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('sobre')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Sobre Nós</span>
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contato')}
                  className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-circle-line text-orange-400"></i>
                  <span>Contato</span>
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-orange-400 mb-4">Nossos Serviços</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Pintura Residencial</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Pintura Comercial</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Pintura de Prédios</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Texturas Decorativas</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Reparos em Gesso</span>
              </li>
              <li className="flex items-start space-x-2">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300">Reparos Gerais</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold text-orange-400 mb-4">Contato</h3>
            <div className="space-y-4">
              <a
                href="tel:+5512981564801"
                onClick={handlePhoneClick}
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                  <i className="ri-phone-line"></i>
                </div>
                <div>
                  <div className="font-bold text-white">(12) 98156-4801</div>
                  <div className="text-xs">Ligue agora</div>
                </div>
              </a>
              <a
                href="https://wa.me/5512981564801"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleWhatsAppClick}
                className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-whatsapp-line"></i>
                </div>
                <div>
                  <div className="font-bold text-white">WhatsApp</div>
                  <div className="text-xs">Atendimento rápido</div>
                </div>
              </a>
            </div>

            <div className="mt-6">
              <h4 className="font-bold mb-3">Formas de Pagamento</h4>
              <p className="text-gray-300 text-sm">
                💳 Cartão de Crédito
                <br />
                📱 PIX
                <br />
                💵 Dinheiro
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black py-6">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between text-sm text-gray-400">
            <div className="flex items-center space-x-4 mb-2 md:mb-0">
              <span>© 2024 - JB PINTURAS - Todos os direitos reservados</span>
              <span>•</span>
              <span>CNPJ: 29.017.962/0001-35</span>
            </div>
            <div>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-400 hover:text-white transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
